<router-outlet></router-outlet>
<div class="dev" *ngIf="isDev">DEV BUILD</div>